import { AdminSplitBuyDetailsSection } from "./sections/split-buy-details.section";

export const AdminSplitBuyDetailsPage = () => <AdminSplitBuyDetailsSection />;
